// Import Firebase SDK components
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

import Logger from '../../utils/logger';

// For debugging - only show in development
Logger.debug("Firebase config keys available:", {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY ? "✓" : "✗",
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN ? "✓" : "✗",
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID ? "✓" : "✗",
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET ? "✓" : "✗",
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID ? "✓" : "✗",
    appId: process.env.REACT_APP_FIREBASE_APP_ID ? "✓" : "✗",
});

// Your Firebase configuration
const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

// Initialize Firebase only if config is valid
if (!firebaseConfig.apiKey) {
    Logger.error("Firebase configuration is incomplete");
} else {
    Logger.info("Firebase initialized successfully");
}

// Initialize Firebase (only once)
const app = initializeApp(firebaseConfig);

// Initialize services
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);
const functions = getFunctions(app, 'us-central1');

// Export the services
export { db, auth, storage, functions };

export default app;